import { useRef } from 'react';

var useLatest = function useLatest(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
};

export default useLatest;